import * as ambassadorWixTipsStaffV1Staff from './tips-staff-v1-staff-tippable-staff.http.js';
import * as ambassadorWixTipsStaffV1StaffTypes from './tips-staff-v1-staff-tippable-staff.types.js';
import * as ambassadorWixTipsStaffV1StaffUniversalTypes from './tips-staff-v1-staff-tippable-staff.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listTippableStaff(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixTipsStaffV1StaffUniversalTypes.ListTippableStaffRequest,
  ambassadorWixTipsStaffV1StaffTypes.ListTippableStaffRequest,
  ambassadorWixTipsStaffV1StaffUniversalTypes.ListTippableStaffResponse,
  ambassadorWixTipsStaffV1StaffTypes.ListTippableStaffResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixTipsStaffV1Staff.listTippableStaff(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/eligible-staff',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Staff as StaffOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  IdentityType as IdentityTypeOriginal,
  IdentityTypeWithLiterals as IdentityTypeWithLiteralsOriginal,
  ListTippableStaffRequest as ListTippableStaffRequestOriginal,
  ListTippableStaffResponse as ListTippableStaffResponseOriginal,
} from './tips-staff-v1-staff-tippable-staff.types.js';
